// Converts the value to a user-friendly format [S - M - L]
export const prettifySize = (value: number): string => {
  if (value === 0) return 'S'
  if (value === 0.5) return 'M'
  if (value === 1) return 'L'
  throw new Error('Invalid value')
}
